"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeGet = require("@styled-system/theme-get");

var _pclnDesignSystem = require("pcln-design-system");

var _IconList = _interopRequireDefault(require("../../../images/IconList"));

var _Body = _interopRequireDefault(require("../../../text/Body"));

var _GuestRatingText = require("../../../../utils/GuestRatingText");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StyledBody = (0, _styledComponents["default"])(_Body["default"]).withConfig({
  componentId: "sc-19ngudu-0"
})(["display:flex;line-height:normal;& >:first-child{margin-right:", "px;}"], (0, _themeGet.themeGet)('space.1'));

function HotelRating(_ref) {
  var className = _ref.className,
      useStars = _ref.useStars,
      rating = _ref.rating,
      ratingMax = _ref.ratingMax,
      color = _ref.color;
  var ratingValue = useStars ? _react["default"].createElement(_IconList["default"], {
    iconFull: "Star",
    iconHalf: "StarHalf",
    value: rating,
    valueMax: ratingMax,
    color: color,
    size: 16
  }) : (0, _GuestRatingText.getGuestRatingText)(rating);
  return _react["default"].createElement(_pclnDesignSystem.Flex, {
    className: className
  }, _react["default"].createElement(StyledBody, {
    bold: true,
    color: color
  }, _react["default"].createElement("span", null, rating, " / ", ratingMax), ratingValue));
}

HotelRating.displayName = 'HotelRating';
HotelRating.propTypes = {
  className: _propTypes["default"].string,
  useStars: _propTypes["default"].bool,
  rating: _propTypes["default"].number,
  ratingMax: _propTypes["default"].number,
  color: _propTypes["default"].string
};
HotelRating.defaultProps = {
  className: '',
  color: 'primary'
};

var _default = (0, _react.memo)(HotelRating);

exports["default"] = _default;